import { useAuthenticationStatus, useUserData } from '@nhost/react';
import { useUser } from 'context/user-context';
import { assistanceUuid } from 'utils/assistedInstallation';

const principal = (value: unknown) => {
  const user = value && typeof value === 'object' ? value as Record<string, unknown> : {};
  return { id: assistanceUuid(user.id) ? user.id : '', staff: user.defaultRole === 'shipaid_admin',
    assignedStaff: Array.isArray(user.roles) && user.roles.includes('shipaid_admin'), disabled: user.disabled === true };
};

/** The existing staff shell also supports explicitly assigned administrator roles. */
export const currentStaffOwner = (value: unknown) => {
  const user = principal(value);
  return !user.disabled && (user.staff || user.assignedStaff) ? user.id : '';
};

/** Effective merchant context may deliberately differ from the signed-in staff account. */
export function useCurrentStaffAccess(allowAssignedRole = false) {
  const { user } = useUser();
  const current = principal(useUserData()), context = principal(user);
  const { isAuthenticated, isLoading } = useAuthenticationStatus();
  const checking = isLoading !== false;
  const currentStaff = current.staff || (allowAssignedRole && current.assignedStaff), contextStaff = context.staff || (allowAssignedRole && context.assignedStaff);
  const allowed = !checking && isAuthenticated === true && !!current.id && current.id === context.id
    && currentStaff && contextStaff && !current.disabled && !context.disabled;
  return { allowed, checking, actor: allowed ? current.id : '',
    key: JSON.stringify([context.id, contextStaff, context.disabled, current.id, currentStaff, current.disabled, isAuthenticated === true, checking]) };
}
